module.exports = __webpack_public_path__ + "static/media/notesIcon.2ef56bae.svg";